import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="9" height="12" viewBox="0 0 9 12" xmlns="http://www.w3.org/2000/svg" {...props}><path fill="#000" d="M5.22 11.74h-.962V2.01L1.61 4.46l-.684-.632L4.74.3l3.813 3.527-.684.632L5.22 2.01z" fillRule="evenodd" /></svg>);